// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fullpagelayout_container__PvLyU {
  height: 100vh;
  width: 100vw;
  background-color: white;
  padding: 0 50px;
  overflow: hidden;
}
@media screen and (max-width: 576px) {
  .fullpagelayout_container__PvLyU {
    padding: 0 20px;
  }
}
.fullpagelayout_container__PvLyU header {
  height: 70px;
  width: 100%;
  display: grid;
  align-items: center;
  grid-auto-flow: column;
  padding: 0 !important;
  margin: 0 !important;
}
.fullpagelayout_container__PvLyU header .fullpagelayout_ArrowBack__tBs\\+5 {
  display: grid;
  place-content: center;
  width: 36px;
  height: 36px;
  background-color: rgb(195, 217, 255);
  border-radius: 100%;
  cursor: pointer;
}
.fullpagelayout_container__PvLyU header .fullpagelayout_headerTitle__9GD9t {
  justify-self: center;
  font-family: Inter;
  font-size: 28px;
  font-weight: 600;
  line-height: 36px;
}
.fullpagelayout_container__PvLyU header .fullpagelayout_right__0qCaz {
  justify-self: end;
  width: -moz-fit-content;
  width: fit-content;
}
.fullpagelayout_container__PvLyU .fullpagelayout_content__qRtg8 {
  width: 100%;
  height: calc(100vh - 85px);
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: auto;
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/Components/layout/fullpagelayout.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EAEA,gBAAA;AAAJ;AAEI;EARJ;IASQ,eAAA;EACN;AACF;AACI;EAEI,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EAEA,qBAAA;EACA,oBAAA;AADR;AAIQ;EACI,aAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,mBAAA;EACA,eAAA;AAFZ;AAMQ;EACI,oBAAA;EAEA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AALZ;AAUQ;EACI,iBAAA;EACA,uBAAA;EAAA,kBAAA;AARZ;AAYI;EACI,WAAA;EACA,0BAAA;EAEA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,cAAA;EACA,SAAA;AAXR","sourcesContent":[".container {\n    height: 100vh;\n    width: 100vw;\n    background-color: white;\n    padding: 0 50px;\n    // background-color: green;\n    overflow: hidden;\n\n    @media screen and (max-width:576px) {\n        padding: 0 20px;\n    }\n\n    header {\n        // justify-content: center;\n        height: 70px;\n        width: 100%;\n        display: grid;\n        align-items: center;\n        grid-auto-flow: column;\n        // background-color: red;\n        padding: 0 !important;\n        margin: 0 !important;\n        // grid-template-rows: 1fr 3fr;\n\n        .ArrowBack {\n            display: grid;\n            place-content: center;\n            width: 36px;\n            height: 36px;\n            background-color: rgba(195, 217, 255, 1);\n            border-radius: 100%;\n            cursor: pointer;\n            // justify-self: flex-start;\n        }\n\n        .headerTitle {\n            justify-self: center;\n            //styleName: material-theme/title/large;\n            font-family: Inter;\n            font-size: 28px;\n            font-weight: 600;\n            line-height: 36px;\n            // text-align: center;\n\n        }\n\n        .right {\n            justify-self: end;\n            width: fit-content;\n        }\n    }\n\n    .content {\n        width: 100%;\n        height: calc(100vh - 85px);\n        // background-color: aliceblue; \n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        overflow: auto;\n        margin: 0;\n    }\n\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `fullpagelayout_container__PvLyU`,
	"ArrowBack": `fullpagelayout_ArrowBack__tBs+5`,
	"headerTitle": `fullpagelayout_headerTitle__9GD9t`,
	"right": `fullpagelayout_right__0qCaz`,
	"content": `fullpagelayout_content__qRtg8`
};
export default ___CSS_LOADER_EXPORT___;
